import type { CandleWithFlag } from "features/chart";

export interface IchimokuLines {
  tenkanSen: (number | null)[];
  kijunSen: (number | null)[];
  chikouSpan: (number | null)[];
  senkouSpanA: (number | null)[];
  senkouSpanB: (number | null)[];
}

function hlMid(data: CandleWithFlag[], i: number, period: number): number | null {
  if (i < period - 1) return null;
  let hi = -Infinity, lo = Infinity;
  for (let j = i - period + 1; j <= i; j++) {
    hi = Math.max(hi, data[j].high);
    lo = Math.min(lo, data[j].low);
  }
  return (hi + lo) / 2;
}

export function calcIchimoku(
  data: CandleWithFlag[],
  tenkanSenPeriod: number,
  kijunSenPeriod: number,
  senkouSpanBPeriod: number,
): IchimokuLines {
  const n = data.length;

  const tenkanSen: (number | null)[] = Array.from({ length: n }, (_, i) => hlMid(data, i, tenkanSenPeriod));
  const kijunSen: (number | null)[] = Array.from({ length: n }, (_, i) => hlMid(data, i, kijunSenPeriod));

  const chikouSpan: (number | null)[] = new Array(n).fill(null);
  for (let j = 0; j < n - kijunSenPeriod; j++) {
    chikouSpan[j] = data[j + kijunSenPeriod].close;
  }

  const senkouSpanA: (number | null)[] = new Array(n + kijunSenPeriod).fill(null);
  const senkouSpanB: (number | null)[] = new Array(n + kijunSenPeriod).fill(null);
  for (let i = 0; i < n; i++) {
    const t = tenkanSen[i], k = kijunSen[i];
    if (t !== null && k !== null) senkouSpanA[i + kijunSenPeriod] = (t + k) / 2;
    const b = hlMid(data, i, senkouSpanBPeriod);
    if (b !== null) senkouSpanB[i + kijunSenPeriod] = b;
  }

  return { tenkanSen, kijunSen, chikouSpan, senkouSpanA, senkouSpanB };
}
